import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./graphic.css";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png"


import img1 from "../../../assets/images/Services/Graphic-Design/graphics-design-img-1.jpg"; // left image
import img2 from "../../../assets/images/Services/Graphic-Design/graphics-design-img-2.jpg"; // right image

export default function Graphic() {
    return (
        <div>
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Graphics Design</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to="/services">Services</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Graphics Design</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section">
                <div className="branding-container">
                    {/* Images Section */}
                    <div className="branding-images">
                        <img src={img1} alt="branding" className="branding-img" />
                        <img src={img2} alt="branding" className="branding-img" />
                    </div>

                    {/* Content Section */}
                    <div className="branding-content">
                        <section className="cta-section">
                            <p>
                                Are you looking to captivate your audience with stunning visuals that speak volumes about your brand? Look no further! At Horizon WebInfo Pvt Ltd, we specialize in crafting compelling graphic designs that breathe life into your brand identity. <br />
                                At the heart of every great design lies a story waiting to be told. We believe in creating designs that not only look visually appealing but also resonate deeply with your target audience. Whether you’re aiming for sleek and modern or vibrant and dynamic, our team of talented graphic designers is here to bring your vision to life.
                            </p>
                            <h3 className='cta-section-business-process it-consult'>Services Offered :</h3>
                        </section>

                        {/* Sections */}
                        <section className='it-consult'>
                        <section className="branding-item">
                            <h4><img src={Arrow} />Logo Design</h4>
                            <p>
                                Your logo is the face of your brand. Let us craft a logo that encapsulates your brand's essence, making a memorable and lasting impression.
                            </p>
                        </section>

                        <section className="branding-item">
                            <h4><img src={Arrow} />Branding and Identity</h4>
                            <p>
                                Consistency is key. We ensure your brand identity is cohesive across all platforms, from business cards to social media profiles, fostering brand recognition and trust.
                            </p>
                        </section>

                        <section className="branding-item">
                            <h4><img src={Arrow} />Website Graphics</h4>
                            <p>
                                Elevate your online presence with visually striking website graphics. Our designs enhance user experience and encourage engagement.
                            </p>
                        </section>

                        <section className="branding-item">
                            <h4><img src={Arrow} />Print Design</h4>
                            <p>
                                From brochures to flyers and beyond, our print designs are tailored to grab attention and convey your message effectively.
                            </p>
                        </section>

                        <section className="branding-item">
                            <h4><img src={Arrow} />Illustrations and Infographics</h4>
                            <p>
                                Transform complex ideas into visually digestible content with our custom illustrations and infographics.
                            </p>
                        </section>

                        {/* Why Choose Us */}
                        <section className="why-choose">
                            <h3>Why Choose Us</h3>
                            <ul>
                                <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                    Our designers thrive on creativity. We don't just design; we craft experiences that leave a lasting impact.</li>
                                <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                    No two brands are the same. We offer personalized solutions that align with your brand's unique identity and goals.</li>
                                <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                    We value your time. Rest assured, your projects will be delivered promptly without compromising quality.</li>
                                <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                    Your input matters. We involve you throughout the design process to ensure we're exceeding your expectations.</li>
                            </ul>
                        </section>

                        {/* CTA */}
                        <section className="cta-section">
                            <h3>Let's Bring Your Vision to Life</h3>
                            <p>
                                Ready to take your brand to new heights with captivating graphic designs? Partner with Horizon WebInfo Pvt Ltd and let’s embark on a creative journey together. Contact us today to discuss how our design expertise can transform your brand!
                            </p>
                            <Link to="/get-a-quote" className="quote-btn1-brand">
                                <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                            </Link>
                        </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}